module.exports = __webpack_public_path__ + "img/52200.9264eb0b.jpg";